import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useQuery } from '@apollo/client';
import { Container, LinearProgress, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';

import { AuthContext } from 'context/AuthContext';
import { Context as activeUnitContext } from 'context/units/activeUnitContext';
import { ME } from 'graphql/queries/user';

import { CookieAccept, Sidebar, Topbar } from './partials';
import { drawerWidth } from './partials/Topbar/Topbar';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%',
        paddingLeft: 0,
        [theme.breakpoints.up('sm')]: {
            paddingLeft: (props) => (props.isDrawerOpen ? 0 : theme.spacing(7))
        }
    },
    shiftContent: {
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0,
        [theme.breakpoints.up('sm')]: {
            marginLeft: drawerWidth
        }
    },
    content: {
        height: '100%',
        minHeight: 'calc(100% - 100px)',
        overflowY: 'auto',
        overflowX: 'hidden',
        paddingTop: theme.spacing(7),
        paddingBottom: theme.spacing(2),
        paddingRight: 0,
        paddingLeft: 0,
        [theme.breakpoints.up('sm')]: {
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 0
        }
    },
    mainContainer: {
        maxWidth: 1920,
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: 0,
        paddingLeft: 0,
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1)
        }
    }
}));

const ReportLayout = ({ children }) => {
    const { data } = useQuery(ME);
    const history = useHistory();
    const { setUser } = useContext(AuthContext);
    if (data && data.me === null) {
        history.push('/sign-in');
    }

    const theme = useTheme();

    const isDesktop = useMediaQuery(theme.breakpoints.between('sm', 'xl'), { defaultMatches: true });

    const [openSidebar, setOpenSidebar] = useState(false);
    const classes = useStyles({ isDrawerOpen: openSidebar });

    const {
        state: { activeUnit }
    } = useContext(activeUnitContext);

    const handleSidebarOpen = () => {
        setOpenSidebar((prev) => !prev);
    };

    const handleSidebarClose = () => {
        setOpenSidebar(false);
    };

    useEffect(() => {
        if (data?.me) {
            const { firstName, lastName, email } = data.me;

            setUser({ firstName, lastName, email });
        }
    }, [data, setUser]);

    return (
        <>
            {data && data.me ? (
                <div className={`${classes.root} ${openSidebar && classes.shiftContent}`}>
                    {!isDesktop && (
                        <Topbar units={data.me.units} activeUnit={activeUnit} handleSidebarOpen={handleSidebarOpen} />
                    )}
                    <Sidebar
                        onClose={handleSidebarClose}
                        open={openSidebar}
                        handleSidebarOpen={handleSidebarOpen}
                        variant={isDesktop ? 'permanent' : 'temporary'}
                        user={data.me}
                        units={data.me.units}
                        activeUnit={activeUnit}
                    />
                    <main className={classes.content}>
                        <Container className={classes.mainContainer}>
                            {(activeUnit && children) || <LinearProgress />}
                        </Container>
                    </main>
                    <CookieAccept />
                </div>
            ) : (
                <LinearProgress />
            )}
        </>
    );
};

ReportLayout.propTypes = {
    children: PropTypes.node
};

export default ReportLayout;
